export default __webpack_public_path__ + "static/offline-fb06cbe6861c0de51ed564f325e0fa70.png";